/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
export var ApiPaths;
(function (ApiPaths) {
    ApiPaths["kiosksGet"] = "/locations/:locationId/kiosks";
    ApiPaths["kiosksPost"] = "/locations/:locationId/kiosks";
    ApiPaths["kioskDelete"] = "/locations/:locationId/kiosks/:kioskId";
    ApiPaths["kioskPut"] = "/locations/:locationId/kiosks/:kioskId";
    ApiPaths["kioskGet"] = "/locations/:locationId/kiosks/:kioskId";
    ApiPaths["kioskCheckInPost"] = "/kiosks/:kioskId/check-in";
    ApiPaths["kioskHeartbeatPost"] = "/kiosks/:kioskId/heartbeat";
    ApiPaths["kioskActivatePost"] = "/kiosks/:kioskId/activate";
    ApiPaths["visitsGet"] = "/locations/:locationId/visits";
    ApiPaths["visitsPost"] = "/locations/:locationId/visits";
    ApiPaths["visitsDailySummaryGet"] = "/locations/:locationId/visits/daily-summary";
    ApiPaths["visitsBulkUpdatePost"] = "/locations/:locationId/visits/bulk-update";
    ApiPaths["visitsBulkDeletePost"] = "/locations/:locationId/visits/bulk-delete";
    ApiPaths["visitsBulkInvitePost"] = "/locations/:locationId/visits/bulk-invite";
    ApiPaths["visitGet"] = "/locations/:locationId/visits/:visitId";
    ApiPaths["visitDelete"] = "/locations/:locationId/visits/:visitId";
    ApiPaths["visitPut"] = "/locations/:locationId/visits/:visitId";
    ApiPaths["visitPrintPost"] = "/locations/:locationId/visits/:visitId/print";
    ApiPaths["visitorPut"] = "/locations/:locationId/visitors/:visitorId";
    ApiPaths["visitorUploadImagePost"] = "/visitors/:visitorId/upload-image";
    ApiPaths["visitorImageGet"] = "/visitors/:visitorId/image";
    ApiPaths["forgottenCardCodePost"] = "/forgotten-card-code";
    ApiPaths["forgottenCardCodeValidatePost"] = "/forgotten-card-code/validate";
    ApiPaths["forgottenCardCodeActivatePost"] = "/forgotten-card-code/activate";
    ApiPaths["preregistrationGet"] = "/pregistration/:preregistrationId";
    ApiPaths["preregistrationPost"] = "/pregistration/:preregistrationId";
    ApiPaths["outlookEventsPost"] = "/outlook-events";
    ApiPaths["outlookAddinGet"] = "/outlook-addin";
    ApiPaths["outlookAddinPost"] = "/outlook-addin";
    ApiPaths["meetingGet"] = "/locations/:locationId/meetings/:meetingId";
    ApiPaths["meetingChangeWatcherPut"] = "/locations/:locationId/meetings/:meetingId/change_watcher";
    ApiPaths["employeesGet"] = "/locations/:locationId/employees";
    ApiPaths["locationsReceptionistsGet"] = "/locations/:locationId/receptionists";
    ApiPaths["locationsReceptionistsPost"] = "/locations/:locationId/receptionists";
    ApiPaths["locationsReceptionistsDelete"] = "/locations/:locationId/receptionists/:userId";
    ApiPaths["locationsGet"] = "/locations";
    ApiPaths["printersGet"] = "/locations/:locationId/printers";
    ApiPaths["printersSendCommandPost"] = "/locations/:locationId/printers/:printerId/sendCommand";
    ApiPaths["printersTestPrintPost"] = "/locations/:locationId/printers/:printerId/testPrint";
    ApiPaths["eventsGet"] = "/locations/:locationId/events";
    ApiPaths["checkAndActivateCardPost"] = "/kiosks/activate-card";
    ApiPaths["checkInMetricPost"] = "/kiosks/check-in-metric";
    ApiPaths["visitsBulkActivatePost"] = "/locations/:locationId/visits/bulk-activate";
    ApiPaths["accessCardsGet"] = "/locations/:locationId/access-cards";
    ApiPaths["cardLogsPost"] = "/card-logs";
})(ApiPaths || (ApiPaths = {}));
//# sourceMappingURL=schema.js.map